<template>
	<div v-if="failed" class="py-20 text-center">
		<p class="mb-4">{{ t('something_went_wrong_while_retrieving_your_data') }}</p>
		<ActionButton @click="loadUpsells">{{ t('reload') }}</ActionButton>
	</div>

	<RouterView v-else-if="ready" />
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue';
import { useFlowStore } from '@/stores/useFlowStore';
import { useI18n } from 'vue-i18n';
import ActionButton from '@/components/ActionButton.vue';

const { t } = useI18n();
const flowStore = useFlowStore();

// The expensive upsell groups are not part of the initial checkout response, so they are loaded
// before any choice step renders (the choice views assume their upsell group is present). While
// loading, the global step loader covers the screen; on failure we offer a retry.
const failed = ref(false);
const ready = computed(() => !!flowStore.checkout?.meta?.upsells?.treatments);

async function loadUpsells() {
	failed.value = false;

	try {
		await flowStore.loadUpsells();
	} catch {
		failed.value = true;
	}
}

onMounted(loadUpsells);
</script>
